<div class="modal-header" *ngIf="header.length!=0">
    <h5 class="modal-title" id="exampleModalLabel">{{header}}</h5>
    
    <button type="button" (click)="modal.dismiss()" class="btn-close" aria-label="Close"></button>

</div>
<!-- <div class="modal-body overflow-auto" [innerHTML]="content" *ngIf="isShareDocs" style="height: 100px;">
</div> -->
<div class="modal-body overflow-auto" [innerHTML]="content" *ngIf="isShareDocs">
</div>
<div class="modal-body"  *ngIf="!isShareDocs||isPopUp" [innerHTML]="content" >
   <!-- {{content}} -->
</div>
<!-- <div class="modal-body"  *ngIf="isPopUp" >
   <h6> {{content}} </h6>
 </div> -->
<div *ngIf="isOkCancel" class="modal-footer">
    <button (click)="modal.dismiss()" type="button" class="btn btn-primary" data-dismiss="modal" *ngIf="!isPopUp">Cancel</button>
    <button (click)="modal.close(true)" type="button" class="btn btn-secondary">OK</button>
</div>
<div *ngIf="!isOkCancel" class="modal-footer">
    <button (click)="modal.dismiss()" type="button" class="btn btn-primary" data-dismiss="modal" *ngIf="!isPopUp">Do not proceed</button>
    <button (click)="modal.close(true)" type="button" class="btn btn-secondary">Proceed</button>
</div>